import { CrewClaimTypeEnum } from 'corso-types';
import { z } from 'zod';

export const claimParamsSchema = z.object({
  claimType: z
    .string()
    .transform((value) => value.replace(/^./, (s) => s.toUpperCase()))
    .pipe(z.enum(CrewClaimTypeEnum)),
});
